
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/life-with-visian",
      function () {
        return require("private-next-pages/life-with-visian.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/life-with-visian"])
      });
    }
  